import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LoginApi } from "../restapi/loginApi";
import { LotScreenSettings } from "../config/uiconfig";
import { DBManager } from "../db/dbManager";
import { DownloadAllContactGiaThuong } from "../db/repository/contactRepo";


export const login = createAsyncThunk(
  "login/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await LoginApi.login(payload);
      if (response.errorCode === 0) {
        //localStorage["userId"]=response.data.dataEx3.userId;

        return response;
      } else {
        return rejectWithValue(response.responseText);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const initialState = {
  accessToken: undefined,
  loggedIn: false,
  inProgress: false,
  tinhId: "",
  prevScreen: LotScreenSettings.CONTACT_LIST_SCREEN, // lưu màn hình để quay lại nếu cần
  mienCuPhapId: 2,
  userFullInfo:  { suDungTinAndroid: 0 },
};
//Khai báo các slice tương ứng với các module state cần quản lý (kiểu như chia nhỏ ra từng phần để quản lý)
export const loginSlice = createSlice({
  name: "login",
  initialState,
  //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
  reducers: {
    updateLastScreen: (state, action) => {
      state.prevScreen = action.payload;
    },
    updateAccessToken: (state, action) => {
      const newState = { ...state, accessToken: action.payload };
      return newState;
    }
  },
  extraReducers: (builder) => {
    // Bắt đầu thực hiện action login (Promise pending)
    builder.addCase(login.pending, (state) => {
      state.inProgress = true;
    });
    // Khi thực hiện action login thành công (Promise fulfilled)
    builder.addCase(login.fulfilled, (state, action) => {
      console.log(`login OK, token:${action.payload.data.access_token}`)
      localStorage["access_token"] = action.payload.data.access_token
      localStorage["mienCuPhapId"] = action.payload.data.mienCuPhapId
      localStorage["tinhId"] = action.payload.data.tinhId
      localStorage["userId"] = action.payload.data.userId
      localStorage["userGroupRole"] = action.payload.data.userGroupRole
      localStorage["localMode"] = action.payload.data.localMode
      localStorage["expireDate"] = action.payload.data.expireDate.substr(0, 10)
      localStorage["userFullInfo"] = JSON.stringify(action.payload.data.userFullInfo)
      localStorage["tg_session_id"] = action.payload.data.userFullInfo.username
      const newState = {
        ...state,
        accessToken: action.payload.data.access_token,
        loggedIn: true,
        inProgress: false,
        tinhId: action.payload.data.tinhId,
        mienCuPhapId: action.payload.data.mienCuPhapId,
        userFullInfo: action.payload.data.userFullInfo,
      }
      const payload = {
        dmDai: action.payload.data.dmDai,
        dmTinh: action.payload.data.dmTinh,
        userDaiConfigPredef: action.payload.data.userDaiConfigPredef,
        daiNgayQuay: action.payload.data.daiNgayQuay,
        userConfig: action.payload.data.userConfig,
        contactsConfigPredef: action.payload.data.contactsConfigPredef,
        userDaiConfig: action.payload.data.userDaiConfig,
        tuKhoaRieng: action.payload.data.tuKhoaRieng,
      }
      DBManager.saveDanhMucToObjectStore(payload)

      return newState
    });
    builder.addCase(login.rejected, (state, action) => {
     
      state = {...state, accessToken: undefined, inProgress: false};
    });
  },
});

export const { resetLogin, updateSessionParam, updateLastScreen,updateAccessToken } = loginSlice.actions;

export default loginSlice.reducer;
